import { FC, useCallback, useEffect, useState } from "react";
import { MAXLENGTH_NOMES, MAX_DATE_PESSOA_FISICA, MIN_DATE_PESSOA_FISICA } from "src/constants";
import { CollectionUtil, DateUtil, Formater, LocalStorage, StringUtil, TypeRecords, ValidateUtil } from "src/framework/commons";
import { ArrayUtil } from "src/framework/commons/ArrayUtil";
import { parseCEP } from "src/framework/commons/masks";
import { InputComboBoxList, InputDate, InputDateTime, InputMoney, InputText } from "src/framework/components/forms";
import { InputDateMonthYear } from "src/framework/components/forms/inputs/InputDateMonthYear";
import { useObservable } from "src/framework/store/storeUtil";
import { paises$, estados$, cidades$, CacheType } from "src/store/global.store";
import { Clientes } from "src/types";
import { configuracoesFinanceira$, dadosProposta$, empresaAtividadeList$, empresaTipoList$, errorsList$, gruposAtividadeList$, naturezaLegalId$, naturezaLegalList$, relacionamentosList$ } from "../../negociacao/Financiamento";
import { BRASILEIRO, CASADO_ID, ESTADOS_CIVIS, ESTADO_CIVIL, ESTADO_CIVIL_CASADO_ID, ESTRANGEIRO, FINANCEIRA_BV_ID, FINANCEIRA_SANTANDER_ID, GENERO, GENERO_LIST, NACIONALIDADE, NATURALIZADO, PARTILHA_BENS, REGIME_BENS } from "../constants";
import { FormEndereco } from "../FormEndereco";
import { FormProfissao } from "../FormProfissao";
import { IAvalistaRequestDom, IPessoaFisicaConjugeRequestDom, IPessoaFisicaProponenteRequestDom, IPessoaFisicaRequestDom, IPessoaJuridicaProponenteRequestDom, IPropostaEnderecoRequestDom } from "../types";
import moment from "moment";
import { isValidCNPJ, isValidCPF } from "@brazilian-utils/brazilian-utils";

interface ITipoPessoa {
    isConjuge: boolean,
    isAvalista: boolean,
    isPessoaFisica: boolean,
    isPessoaJuridica: boolean,
}
interface FormPessoaProperties {
    dados: null | IAvalistaRequestDom | IPessoaFisicaConjugeRequestDom | IPessoaFisicaProponenteRequestDom | IPessoaJuridicaProponenteRequestDom,
    dadosCliente?: Clientes | null,
    isConjuge?: boolean,
    isAvalista?: boolean,
    isPessoaFisica?: boolean,
    isPessoaJuridica?: boolean,
    readonly?: boolean,
    indexAvalista?: number,
    isValid?: (value: boolean) => void,
    onChange: (dados: any, tipoPessoa: ITipoPessoa) => void,
    financeira_id: number | null,
}

const FormPessoa: FC<FormPessoaProperties> = ({
    dados,
    dadosCliente,
    isPessoaFisica = false,
    isPessoaJuridica = false,
    isConjuge = false,
    isAvalista = false,
    readonly = false,
    indexAvalista,
    isValid,
    onChange,
    financeira_id
}) => {

    const paisesListState = useObservable(paises$);

    const [estadoCivilState, setEstadoCivilState] = useState<any>(null);
    const [naturezaLegalState, setNatureLegalState] = useState<any>(null);
    const [atividadeState, setAtividadeState] = useState<any>(null);
    const [grupoAtividadeState, setGrupoAtividadeState] = useState<any>(null);
    const [relacionamentosState, setRelacionamentosState] = useState<any>(null);
    const [tipoEmpresaState, setTipoEmpresaState] = useState<any>(null);
    const [generoState, setGeneroState] = useState<any>(null);
    const [nacionalidade, setNacionalidade] = useState<any>(null);
    const [paisNacionalidade, setPaisNacionalidade] = useState<any>(null);
    const [regimeBensState, setRegimeBensState] = useState<any>(null);
    const configfuracoesFinanceira = useObservable(configuracoesFinanceira$);

    const errorsList = useObservable(errorsList$)
    const atividadeList = useObservable(empresaAtividadeList$)
    const grupoAtividadeList = useObservable(gruposAtividadeList$)
    const naturezaLegalList = useObservable(naturezaLegalList$)
    const tipoEmpresaList = useObservable(empresaTipoList$)
    const relacionamentosList = useObservable(relacionamentosList$)
    const naturezaLegalId = useObservable(naturezaLegalId$)


    const handleValidChange = () => {
        if (isValid) {
        }
    }

    const resolveTipoPessoa = (): ITipoPessoa => {
        return {
            isPessoaFisica: isPessoaFisica,
            isPessoaJuridica: isPessoaJuridica,
            isConjuge: isConjuge,
            isAvalista: isAvalista
        }
    }

    const pessoaStringType = (): string => {
        const _tipo = resolveTipoPessoa();
        if (_tipo.isPessoaFisica && _tipo.isConjuge && _tipo.isAvalista) {
            return "fisica-conjuge-avalista"
        }

        if (_tipo.isPessoaFisica && !_tipo.isConjuge && _tipo.isAvalista) {
            return "fisica-avalista"
        }

        if (_tipo.isPessoaFisica && _tipo.isConjuge && !_tipo.isAvalista) {
            return "fisica-conjuge"
        }

        if (_tipo.isPessoaFisica && !_tipo.isConjuge && !_tipo.isAvalista) {
            return "fisica";
        }

        if (_tipo.isPessoaJuridica && _tipo.isConjuge && _tipo.isAvalista) {
            return "juridica-conjuge-avalista";
        }

        if (_tipo.isPessoaJuridica && !_tipo.isConjuge && !_tipo.isAvalista) {
            return "juridica";
        }

        if (_tipo.isPessoaJuridica && !_tipo.isConjuge && _tipo.isAvalista) {
            return "juridica-avalista"
        }

        return ""
    }

    const resolveDataNacimentoFundacao = (): Date | null => {
        const stringDate = isPessoaJuridica ? (dados as IPessoaJuridicaProponenteRequestDom)?.data_fundacao : (dados as IPessoaFisicaProponenteRequestDom)?.data_nascimento

        return DateUtil.stringToDate(stringDate);
    }

    const resolveNome = (): string | null => {
        if (isConjuge || isAvalista) {
            if ((dados as any)?.nome){
                return maskEspeciais((dados as any)?.nome, true);
            } else {
                return null;
            }
        }

        if ((isPessoaFisica || isPessoaJuridica) && !isAvalista && !isConjuge) {
            if (dadosCliente?.nome) {
                return maskEspeciais(dadosCliente?.nome, true)
            } else {
                return null;
            }
        }
        return null
    }

    useEffect(() => {
        const _nacionalidade = NACIONALIDADE?.find((p: any) => p.value === (dados as IPessoaFisicaRequestDom)?.nacionalidade) || null

        if (_nacionalidade?.value === BRASILEIRO) {
            const _pais = paises$.getValue()?.data?.find((p: any) => p.nome.toUpperCase() === "Brasil".toUpperCase()) || null;
            setPaisNacionalidade(_pais);
        }

        if (_nacionalidade?.value !== BRASILEIRO) {
            setPaisNacionalidade(null);
        }

        setNacionalidade(_nacionalidade)
    }, [(dados as IPessoaFisicaRequestDom)?.nacionalidade]);

    useEffect(() => {
        const _paisNacionalidade = paises$.getValue()?.data?.find((p: any) => p.id === (dados as IPessoaFisicaRequestDom)?.nacionalidade_pais) || null
        setPaisNacionalidade(_paisNacionalidade)
    }, [(dados as IPessoaFisicaRequestDom)?.nacionalidade_pais]);


    useEffect(() => {
        const _genero = GENERO_LIST.find((g) => g.id === (dados as any)?.genero) || null
        setGeneroState(_genero)
    }, [(dados as IPessoaFisicaRequestDom)?.genero]);

    useEffect(() => {
        const _estadoCivil = ESTADOS_CIVIS?.find((ec) => ec.id === (dados as any)?.estado_civil) || null
        if (_estadoCivil?.id !== ESTADO_CIVIL_CASADO_ID) {
            setRegimeBensState(null)
        }
        setEstadoCivilState(_estadoCivil)
    }, [(dados as any)?.estado_civil]);

    useEffect(() => {
        const _regime = PARTILHA_BENS?.find((g) => g.id === (dados as any)?.partilha_bens) || null
        setRegimeBensState(_regime)
    }, [(dados as any)?.partilha_bens]);

    useEffect(() => {
        const _natureza = naturezaLegalList?.find((i: any) => i.id === (dados as IPessoaJuridicaProponenteRequestDom)?.natureza_legal) || null
        setNatureLegalState(_natureza)
        naturezaLegalId$.next(_natureza?.id || null)
    }, [(dados as IPessoaJuridicaProponenteRequestDom)?.natureza_legal]);

    useEffect(() => {
        const _grupoAtividade = grupoAtividadeList?.find((i: any) => i.id === (dados as IPessoaJuridicaProponenteRequestDom)?.grupo_atividades) || null
        setGrupoAtividadeState(_grupoAtividade)
    }, [(dados as IPessoaJuridicaProponenteRequestDom)?.grupo_atividades]);

    useEffect(() => {
        const _atividade = atividadeList?.find((i: any) => i.id === (dados as IPessoaJuridicaProponenteRequestDom)?.atividade) || null
        setAtividadeState(_atividade)
    }, [(dados as IPessoaJuridicaProponenteRequestDom)?.atividade]);

    useEffect(() => {
        const _tipoEmpresa = tipoEmpresaList?.find((i: any) => i.id === (dados as IPessoaJuridicaProponenteRequestDom)?.tipo_empresa) || null
        setTipoEmpresaState(_tipoEmpresa)
    }, [(dados as IPessoaJuridicaProponenteRequestDom)?.tipo_empresa]);

    useEffect(() => {
        const _relacionamento = relacionamentosList?.find((i: any) => i.id === (dados as IPessoaJuridicaProponenteRequestDom)?.relacionamento_legal) || null
        setRelacionamentosState(_relacionamento)
    }, [(dados as IPessoaJuridicaProponenteRequestDom)?.relacionamento_legal, relacionamentosList]);

    const maskEspeciais = useCallback((str: any, clear?: boolean)=>{
        if(str){
            let _str = str;
            _str = _str.replace(/[^a-zA-Z0-9-' ]/g,"");
            if (clear) {
                _str = str?.normalize('NFD').replace(/([\u0300-\u036f]|[^0-9a-zA-Z- ])/g, '')
                _str = StringUtil.clear(_str)?.trimStart()?.replace(/\s{2,}/g, ' ');
            }
            return _str;
        }
        return null;
    },[dados, dadosCliente])

    const maskRG = useCallback((str: any)=>{
        if(str){
            let _str = str;
            _str = _str.replace(/[^a-zA-Z0-9-/]/g,"");
            return _str;
        }
        return null;
    },[dados, dadosCliente])

    const phoneError = useCallback((phone: any)=>{
        let _phone = phone;
        _phone = _phone?.replace(/\D/g, "");
        _phone = _phone?.replace(/^0/, "");
        return (_phone?.length > 0 &&_phone?.length !== 11);
    },[dados])

    const maskPhone = useCallback((phone: any)=>{
        let _phone = phone;
        _phone = _phone?.replace(/\D/g, "");
        _phone = _phone?.replace(/^0/, "");

        if (_phone?.length > 10) {
            _phone = _phone?.replace(/^(\d\d)(\d{5})(\d{4}).*/, "($1) $2-$3");
        } else if (_phone?.length > 5) {
            _phone = _phone?.replace(/^(\d\d)(\d{4})(\d{0,4}).*/, "($1) $2-$3");
        } else if (_phone?.length > 2) {
            _phone = _phone?.replace(/^(\d\d)(\d{0,5})/, "($1) $2");
        } else if (_phone?.length > 1) {
            _phone = _phone?.replace(/^(\d*)/, "($1");
        }
    
        return _phone;
    },[dados])

    const getDataNascimentoHelperText = () => {
        if (ArrayUtil.contains(errorsList, "pessoa_fisica#data_nascimento#min")) {
            return `Idade mínima permitida: ${MIN_DATE_PESSOA_FISICA} anos`
        }

        if (ArrayUtil.contains(errorsList, "pessoa_fisica#data_nascimento#max")) {
            return `Idade máxima permitida: ${MAX_DATE_PESSOA_FISICA} anos`
        }

        if (ArrayUtil.contains(errorsList, "pessoa_fisica#data_nascimento")) {
            return `Campo obrigatório`
        }

        return ""
    }
    const getTelefoneHelperText = () => {
        let _phone = dados?.telefone || "";
        _phone = _phone?.replace(/\D/g, "");
        _phone = _phone?.replace(/^0/, "");
        
        if(_phone?.length > 0 && _phone?.length !== 11){
            return "É obrigatório informar o DDD + 9 dígitos!";
        }

        return "";
    }

    const validarTexto = (texto: string): boolean => {
        if (!texto) return true;
        
        // Remover acentos
        const textoSemAcentos = maskEspeciais(texto, true);
        
        // Verificar se o texto sem acentos corresponde ao formato esperado
        const regex = /^[A-Za-z]{2,}(?:\s[A-Za-z]+)+\b$/;
        return regex.test(textoSemAcentos);
    }

    const withErrors = (): boolean => {
        return (ArrayUtil.contains(errorsList, "pessoa_fisica#nome_mae_dois_nomes") ||
        ArrayUtil.contains(errorsList, "pessoa_fisica.conjuge#nome_mae_dois_nomes") ||
        ArrayUtil.contains(errorsList, `avalistas#${indexAvalista}#nome_mae_dois_nomes`) ||
        ArrayUtil.contains(errorsList, `avalistas#${indexAvalista}#conjuge.nome_mae_dois_nomes`));
    }

    return <div className={`FormPessoa`}>
        {(isConjuge || isAvalista) && <>
            <div className="row">
                <div className="X12">
                    <h4>Dados pessoais</h4>
                </div>
            </div>
        </>}
        <div className="row">
            {/* Nome completo / Razão Social */}
            <div className="X12 M6">
                <InputText
                    disabled={(!isConjuge && !isAvalista) || readonly}
                    fullWidth
                    label={isPessoaJuridica ? "Razão social" : "Nome completo"}
                    value={resolveNome()}
                    maxLength={MAXLENGTH_NOMES}
                    onChange={(event: any) => {
                        if (isConjuge || isAvalista) {
                            const value = event.target.value;
                            const _state = CollectionUtil.merge({}, dados)
                            if ((_state as any)) {
                                (_state as any).nome = value;
                                onChange(_state, resolveTipoPessoa())
                            }
                        }
                    }}
                    error={
                        (isConjuge && !isAvalista && ArrayUtil.contains(errorsList, "pessoa_fisica.conjuge#nome", true))
                        || (!isConjuge && isAvalista && ArrayUtil.contains(errorsList, `avalistas#${indexAvalista}#nome`, true))
                        || (isConjuge && isAvalista && ArrayUtil.contains(errorsList, `avalistas#${indexAvalista}#conjuge.nome`, true))
                    }
                    onBlur={()=>{
                        if(!(dados as any)?.nome){
                            if(isConjuge && !isAvalista){
                                errorsList$.next([...errorsList, "pessoa_fisica.conjuge#nome"])
                            }else if(!isConjuge && isAvalista){
                                errorsList$.next([...errorsList, `avalistas#${indexAvalista}#nome`])
                            }else if(isConjuge && isAvalista){
                                errorsList$.next([...errorsList, `avalistas#${indexAvalista}#conjuge.nome`])
                            }
                        }else{
                            if(isConjuge && !isAvalista){
                                errorsList$.next(errorsList.filter((error: any)=>error !== `pessoa_fisica.conjuge#nome`))
                            }else if(!isConjuge && isAvalista){
                                errorsList$.next(errorsList.filter((error: any)=>error !== `avalistas#${indexAvalista}#nome`))
                            }else if(isConjuge && isAvalista){
                                errorsList$.next(errorsList.filter((error: any)=>error !== `avalistas#${indexAvalista}#conjuge.nome`))
                            }
                        }
                    }}
                />
            </div>

            {/* CPF / CNPJ */}
            <div className="X12 M6">
                <InputText
                    disabled={(!isConjuge && !isAvalista) || readonly}
                    fullWidth
                    mask={isPessoaJuridica ? "cnpj" : "cpf"}
                    label={isPessoaJuridica ? "CNPJ" : "CPF"}
                    value={isPessoaFisica && (isAvalista || isConjuge) ? Formater.toString((dados as any)?.documento?.replace(/\D/g, ""), TypeRecords.CPF_CNPJ) : Formater.toString(dadosCliente?.documento?.replace(/\D/g, ""), TypeRecords.CPF_CNPJ)}
                    onChange={(event: any) => {
                        if (isConjuge || isAvalista) {
                            const _state = CollectionUtil.merge({}, dados)
                            const value = event.target.value;
                            if ((_state)) {
                                _state.documento = value.replace(/\D/g, "");
                                onChange(_state, resolveTipoPessoa())
                            }
                        }
                    }}
                    error={
                        (isConjuge && !isAvalista && ArrayUtil.contains(errorsList, "pessoa_fisica.conjuge#documento", true))
                        || (!isConjuge && isAvalista && ArrayUtil.contains(errorsList, `avalistas#${indexAvalista}#documento`, true))
                        || (isConjuge && isAvalista && ArrayUtil.contains(errorsList, `avalistas#${indexAvalista}#conjuge.documento`, true))
                    }
                    onBlur={()=>{
                        if(!(dados as any)?.documento || (isPessoaJuridica ? !isValidCNPJ((dados as any)?.documento) : !isValidCPF((dados as any)?.documento))){
                            if(isConjuge && !isAvalista){
                                errorsList$.next([...errorsList, "pessoa_fisica.conjuge#documento"])
                            }else if(!isConjuge && isAvalista){
                                errorsList$.next([...errorsList, `avalistas#${indexAvalista}#documento`])
                            }else if(isConjuge && isAvalista){
                                errorsList$.next([...errorsList, `avalistas#${indexAvalista}#conjuge.documento`])
                            }
                        }else{
                            if(isConjuge && !isAvalista){
                                errorsList$.next(errorsList.filter((error: any)=>error !== `pessoa_fisica.conjuge#documento`))
                            }else if(!isConjuge && isAvalista){
                                errorsList$.next(errorsList.filter((error: any)=>error !== `avalistas#${indexAvalista}#documento`))
                            }else if(isConjuge && isAvalista){
                                errorsList$.next(errorsList.filter((error: any)=>error !== `avalistas#${indexAvalista}#conjuge.documento`))
                            }
                        }
                    }}
                />
            </div>

            {/* TODO: Descomentar e substituir value após subir alterações do SAP https://tic-intelbras.atlassian.net/browse/SOL-1258?focusedCommentId=99246  */}
            {isPessoaJuridica && <div className="X12 M6">
                <InputText
                    disabled={readonly}
                    fullWidth
                    label="Nome fantasia"
                    value={(dados as IPessoaJuridicaProponenteRequestDom)?.fantasia?.normalize('NFD').replace(/([\u0300-\u036f]|[^0-9a-zA-Z- ])/g, '')}
                    // value={maskEspeciais((dados as IPessoaJuridicaProponenteRequestDom)?.fantasia, true)}
                    // minLength={2}
                    maxLength={MAXLENGTH_NOMES}
                    onChange={(event: any) => {
                        const value = event.target.value;
                        const _state = CollectionUtil.merge({}, dados)
                        if ((_state as IPessoaJuridicaProponenteRequestDom)) {
                            (_state as IPessoaJuridicaProponenteRequestDom).fantasia = value;
                            onChange(_state, resolveTipoPessoa())
                        }
                    }}
                    error={
                        (!isConjuge && !isAvalista && ArrayUtil.contains(errorsList, "pessoa_juridica#fantasia", true))
                        // || maskEspeciais((dados as IPessoaJuridicaProponenteRequestDom)?.fantasia, true)?.length < 2
                        // || maskEspeciais((dados as IPessoaJuridicaProponenteRequestDom)?.fantasia, true)?.length > MAXLENGTH_NOMES
                        // || !validarTexto((dados as IPessoaJuridicaProponenteRequestDom)?.fantasia || '')
                    }
                />
            </div>}

            {/* Documento de indentidade /  */}
            {(isPessoaFisica || isConjuge || isAvalista) && <>
                <div className="X12 M6">
                    <InputText
                        disabled={readonly}
                        fullWidth
                        label="Documento de identidade"
                        value={maskRG((dados as IPessoaFisicaRequestDom)?.documento_rg_rne)}
                        onChange={(event: any) => {
                            const _state = CollectionUtil.merge({}, dados)
                            if (_state) {
                                (_state as IPessoaFisicaRequestDom).documento_rg_rne = event.target.value
                                onChange(_state, resolveTipoPessoa())
                            }
                        }}
                        error={
                            (!isAvalista && isConjuge && ArrayUtil.contains(errorsList, "pessoa_fisica#documento_rg_rne"))
                            || (isConjuge && !isAvalista && ArrayUtil.contains(errorsList, "pessoa_fisica.conjuge#documento_rg_rne"))
                            || (isAvalista && !isConjuge && ArrayUtil.contains(errorsList, `avalistas#${indexAvalista}#documento_rg_rne`))
                            || (isAvalista && isConjuge && ArrayUtil.contains(errorsList, `avalistas#${indexAvalista}#conjuge.documento_rg_rne`))
                        }
                        onBlur={()=>{
                            if(!(dados as any)?.documento_rg_rne){
                                if(isConjuge && !isAvalista){
                                    errorsList$.next([...errorsList, "pessoa_fisica.conjuge#documento_rg_rne"])
                                }else if(!isConjuge && isAvalista){
                                    errorsList$.next([...errorsList, `avalistas#${indexAvalista}#documento_rg_rne`])
                                }else if(isConjuge && isAvalista){
                                    errorsList$.next([...errorsList, `avalistas#${indexAvalista}#conjuge.documento_rg_rne`])
                                }
                            }else{
                                if(isConjuge && !isAvalista){
                                    errorsList$.next(errorsList.filter((error: any)=>error !== `pessoa_fisica.conjuge#documento_rg_rne`))
                                }else if(!isConjuge && isAvalista){
                                    errorsList$.next(errorsList.filter((error: any)=>error !== `avalistas#${indexAvalista}#documento_rg_rne`))
                                }else if(isConjuge && isAvalista){
                                    errorsList$.next(errorsList.filter((error: any)=>error !== `avalistas#${indexAvalista}#conjuge.documento_rg_rne`))
                                }
                            }
                        }}
                    />
                </div>
            </>}

            {/* Data de Nacimento / Data de Fundação */}
            <div className="X12 M6">
                <InputDate
                    helperText={getDataNascimentoHelperText()}
                    fullWidth
                    disabled={readonly}
                    label={`Data de ${isPessoaJuridica ? "fundação" : "nascimento"}`}
                    value={resolveDataNacimentoFundacao()}
                    format="dd/MM/yyyy"
                    maxDate={isPessoaJuridica ? undefined : new Date()}
                    minDate={new Date(1900, 0, 1)}
                    onChange={(newDate) => {
                        const _state = CollectionUtil.merge({}, dados)
                        const errors = errorsList$.getValue() ? errorsList$.getValue() : []
                        errorsList$.next([...errors.filter((item: string) => !item.includes("pessoa_fisica#data_nascimento"))])

                        if (_state) {
                            const value = newDate;
                            if (isPessoaFisica) {
                                (_state as IPessoaFisicaProponenteRequestDom).data_nascimento = value;
                            }

                            if (isPessoaJuridica) {
                                (_state as IPessoaJuridicaProponenteRequestDom).data_fundacao = value;
                            }

                            onChange(_state, resolveTipoPessoa())
                        }
                    }}
                    error={
                        (!isConjuge && !isAvalista && ArrayUtil.contains(errorsList, "pessoa_fisica#data_nascimento"))
                        || (isConjuge && !isAvalista && ArrayUtil.contains(errorsList, "pessoa_fisica.conjuge#data_nascimento"))
                        || (!isConjuge && isAvalista && ArrayUtil.contains(errorsList, `avalistas#${indexAvalista}#data_nascimento`))
                        || (isConjuge && isAvalista && ArrayUtil.contains(errorsList, `avalistas#${indexAvalista}#conjuge.data_nascimento`))
                        || (!isConjuge && !isAvalista && ArrayUtil.contains(errorsList, "pessoa_juridica#data_fundacao"))
                        || (!isConjuge && !isAvalista && ArrayUtil.contains(errorsList, "pessoa_fisica#data_nascimento#min"))
                        || (!isConjuge && !isAvalista && ArrayUtil.contains(errorsList, "pessoa_fisica#data_nascimento#max"))
                    }
                    onBlur={()=>{
                        if(!(dados as any).data_nascimento && !isPessoaJuridica){
                            if(isConjuge && !isAvalista){
                                errorsList$.next([...errorsList, "pessoa_fisica.conjuge#data_nascimento"])
                            }else if(!isConjuge && isAvalista){
                                errorsList$.next([...errorsList, `avalistas#${indexAvalista}#data_nascimento`])
                            }else if(isConjuge && isAvalista){
                                errorsList$.next([...errorsList, `avalistas#${indexAvalista}#conjuge.data_nascimento`])
                            }
                        }else{
                            if(isConjuge && !isAvalista){
                                errorsList$.next(errorsList.filter((error: any)=>error !== `pessoa_fisica.conjuge#data_nascimento`))
                            }else if(!isConjuge && isAvalista){
                                errorsList$.next(errorsList.filter((error: any)=>error !== `avalistas#${indexAvalista}#data_nascimento`))
                            }else if(isConjuge && isAvalista){
                                errorsList$.next(errorsList.filter((error: any)=>error !== `avalistas#${indexAvalista}#conjuge.data_nascimento`))
                            }
                        }
                    }}
                />
            </div>

            {isPessoaJuridica && <>
                <div className="X12 M6">
                    <InputComboBoxList
                        disabled={readonly || !naturezaLegalList?.length}
                        label="Natureza legal"
                        textField="nome"
                        valueField="id"
                        value={naturezaLegalState}
                        options={naturezaLegalList || []}
                        onChange={(_naturezaLegal) => {
                            const _state = CollectionUtil.merge({}, dados)
                            if (_state) {
                                (_state as IPessoaJuridicaProponenteRequestDom).natureza_legal = _naturezaLegal?.id || null
                                naturezaLegalId$.next(_naturezaLegal?.id || null)
                                onChange(_state, resolveTipoPessoa())
                            }
                            handleValidChange();
                        }}
                        error={ArrayUtil.contains(errorsList, "pessoa_juridica#natureza_legal")}
                    />
                </div>

                <div className="X12 M6">
                    <InputComboBoxList
                        disabled={readonly || !grupoAtividadeList?.length}
                        label="Grupo de atividade"
                        textField="nome"
                        valueField="id"
                        value={grupoAtividadeState}
                        options={grupoAtividadeList || []}
                        onChange={(_grupoAtividade) => {
                            const _state = CollectionUtil.merge({}, dados)
                            if (_state) {
                                (_state as IPessoaJuridicaProponenteRequestDom).grupo_atividades = _grupoAtividade?.id || null
                                onChange(_state, resolveTipoPessoa())
                            }
                            handleValidChange();
                        }}
                        error={ArrayUtil.contains(errorsList, "pessoa_juridica#grupo_atividades")}
                    />
                </div>
                <div className="X12 M6">
                    <InputComboBoxList
                        disabled={readonly || !atividadeList?.length}
                        label="Tipo atividade"
                        textField="nome"
                        valueField="id"
                        value={atividadeState}
                        options={atividadeList}
                        onChange={(_atividade) => {
                            const _state = CollectionUtil.merge({}, dados)
                            if (_state) {
                                (_state as IPessoaJuridicaProponenteRequestDom).atividade = _atividade?.id || null
                                onChange(_state, resolveTipoPessoa())
                            }
                            handleValidChange();
                        }}
                        error={ArrayUtil.contains(errorsList, "pessoa_juridica#atividade")}
                    />
                </div>
                <div className="X12 M6">
                    <InputComboBoxList
                        disabled={readonly || !tipoEmpresaList?.length}
                        label="Tipo empresa"
                        textField="nome"
                        valueField="id"
                        value={tipoEmpresaState}
                        options={tipoEmpresaList || []}
                        onChange={(_tipoEmpresa) => {
                            const _state = CollectionUtil.merge({}, dados)
                            if (_state) {
                                (_state as IPessoaJuridicaProponenteRequestDom).tipo_empresa = _tipoEmpresa?.id || null
                                onChange(_state, resolveTipoPessoa())
                            }
                            handleValidChange();
                        }}
                        error={ArrayUtil.contains(errorsList, "pessoa_juridica#tipo_empresa")}
                    />
                </div>
            </>}

            {!isPessoaJuridica && <>
                <div className="X12 M6">
                    <InputComboBoxList
                        disabled={readonly}
                        label="Nacionalidade"
                        textField="text"
                        valueField="value"
                        value={nacionalidade}
                        options={NACIONALIDADE || []}
                        onChange={(_nacionalidade) => {
                            const _state = CollectionUtil.merge({}, dados)
                            if (_state) {
                                (_state as IPessoaFisicaRequestDom).nacionalidade = _nacionalidade?.value || null;
                                if (_nacionalidade?.value === BRASILEIRO) {
                                    const _pais = paises$.getValue()?.data?.find((p: any) => p.nome.toUpperCase() === "Brasil".toUpperCase()) || null;
                                    (_state as IPessoaFisicaRequestDom).nacionalidade_pais = _pais?.id || null;
                                }
                                if (_nacionalidade === null) {
                                    (_state as IPessoaFisicaRequestDom).nacionalidade_pais = null;
                                }
                                onChange(_state, resolveTipoPessoa())
                            }
                            handleValidChange();
                        }}
                        error={
                            (!isConjuge && !isAvalista && ArrayUtil.contains(errorsList, "pessoa_fisica#nacionalidade"))
                            || (isConjuge && !isAvalista && ArrayUtil.contains(errorsList, "pessoa_fisica.conjuge#nacionalidade"))
                            || (!isConjuge && isAvalista && ArrayUtil.contains(errorsList, `avalistas#${indexAvalista}#nacionalidade`))
                            || (isConjuge && isAvalista && ArrayUtil.contains(errorsList, `avalistas#${indexAvalista}#conjuge.nacionalidade`))
                        }
                        onBlur={()=>{
                            if(!(dados as any).nacionalidade && !isPessoaJuridica){
                                if(isConjuge && !isAvalista){
                                    errorsList$.next([...errorsList, "pessoa_fisica.conjuge#nacionalidade"])
                                }else if(!isConjuge && isAvalista){
                                    errorsList$.next([...errorsList, `avalistas#${indexAvalista}#nacionalidade`])
                                }else if(isConjuge && isAvalista){
                                    errorsList$.next([...errorsList, `avalistas#${indexAvalista}#conjuge.nacionalidade`])
                                }
                            }else{
                                if(isConjuge && !isAvalista){
                                    errorsList$.next(errorsList.filter((error: any)=>error !== `pessoa_fisica.conjuge#nacionalidade`))
                                }else if(!isConjuge && isAvalista){
                                    errorsList$.next(errorsList.filter((error: any)=>error !== `avalistas#${indexAvalista}#nacionalidade`))
                                }else if(isConjuge && isAvalista){
                                    errorsList$.next(errorsList.filter((error: any)=>error !== `avalistas#${indexAvalista}#conjuge.nacionalidade`))
                                }
                            }
                        }}
                    />
                </div>
                <div className="X12 M6">
                    <InputComboBoxList
                        disabled={readonly || ![ESTRANGEIRO, NATURALIZADO].includes(String((dados as IPessoaFisicaRequestDom)?.nacionalidade))}
                        label="País de nacionalidade"
                        textField="nome"
                        valueField="id"
                        value={paisNacionalidade}
                        options={paisesListState?.data || []}
                        onChange={(_pais) => {
                            if (dados) {
                                (dados as IPessoaFisicaRequestDom).nacionalidade_pais = _pais?.nome || undefined
                                onChange({ ...dados }, resolveTipoPessoa())
                            }
                            handleValidChange();
                        }}
                        error={
                            (!isConjuge && !isAvalista && ArrayUtil.contains(errorsList, "pessoa_fisica#nacionalidade_pais"))
                            || (isConjuge && !isAvalista && ArrayUtil.contains(errorsList, "pessoa_fisica.conjuge#nacionalidade_pais"))
                            || (!isConjuge && isAvalista && ArrayUtil.contains(errorsList, `avalistas#${indexAvalista}#nacionalidade_pais`))
                            || (isConjuge && isAvalista && ArrayUtil.contains(errorsList, `avalistas#${indexAvalista}#conjuge.nacionalidade_pais`))
                        }
                        onBlur={()=>{
                            if(!(dados as any).nacionalidade_pais && !isPessoaJuridica){
                                if(isConjuge && !isAvalista){
                                    errorsList$.next([...errorsList, "pessoa_fisica.conjuge#nacionalidade_pais"])
                                }else if(!isConjuge && isAvalista){
                                    errorsList$.next([...errorsList, `avalistas#${indexAvalista}#nacionalidade_pais`])
                                }else if(isConjuge && isAvalista){
                                    errorsList$.next([...errorsList, `avalistas#${indexAvalista}#conjuge.nacionalidade_pais`])
                                }
                            }else{
                                if(isConjuge && !isAvalista){
                                    errorsList$.next(errorsList.filter((error: any)=>error !== `pessoa_fisica.conjuge#nacionalidade_pais`))
                                }else if(!isConjuge && isAvalista){
                                    errorsList$.next(errorsList.filter((error: any)=>error !== `avalistas#${indexAvalista}#nacionalidade_pais`))
                                }else if(isConjuge && isAvalista){
                                    errorsList$.next(errorsList.filter((error: any)=>error !== `avalistas#${indexAvalista}#conjuge.nacionalidade_pais`))
                                }
                            }
                        }}
                    />
                </div>

                {/* Genero */}
                <div className="X12 M6">
                    <InputComboBoxList
                        disabled={readonly}
                        label="Sexo"
                        textField="nome"
                        valueField="id"
                        value={generoState}
                        options={GENERO_LIST}
                        onChange={(_genero) => {
                            if (dados) {
                                (dados as IPessoaFisicaRequestDom).genero = _genero?.id || null
                                onChange({ ...dados }, resolveTipoPessoa())
                            }
                            handleValidChange();
                        }}
                        error={
                            (!isConjuge && !isAvalista && ArrayUtil.contains(errorsList, "pessoa_fisica#genero"))
                            || (isConjuge && !isAvalista && ArrayUtil.contains(errorsList, "pessoa_fisica.conjuge#genero"))
                            || (!isConjuge && isAvalista && ArrayUtil.contains(errorsList, `avalistas#${indexAvalista}#genero`))
                            || (isConjuge && isAvalista && ArrayUtil.contains(errorsList, `avalistas#${indexAvalista}#conjuge.genero`))
                        }
                        onBlur={()=>{
                            if(!(dados as any).genero && !isPessoaJuridica){
                                if(isConjuge && !isAvalista){
                                    errorsList$.next([...errorsList, "pessoa_fisica.conjuge#genero"])
                                }else if(!isConjuge && isAvalista){
                                    errorsList$.next([...errorsList, `avalistas#${indexAvalista}#genero`])
                                }else if(isConjuge && isAvalista){
                                    errorsList$.next([...errorsList, `avalistas#${indexAvalista}#conjuge.genero`])
                                }
                            }else{
                                if(isConjuge && !isAvalista){
                                    errorsList$.next(errorsList.filter((error: any)=>error !== `pessoa_fisica.conjuge#genero`))
                                }else if(!isConjuge && isAvalista){
                                    errorsList$.next(errorsList.filter((error: any)=>error !== `avalistas#${indexAvalista}#genero`))
                                }else if(isConjuge && isAvalista){
                                    errorsList$.next(errorsList.filter((error: any)=>error !== `avalistas#${indexAvalista}#conjuge.genero`))
                                }
                            }
                        }}
                    />  
                </div>

                {/* Nome da mãe */}
                {/* TODO: Descomentar e substituir value após subir alterações do SAP https://tic-intelbras.atlassian.net/browse/SOL-1257?focusedCommentId=99247 */}
                <div className="X12 M6">
                    <InputText
                        disabled={readonly}
                        fullWidth
                        // minLength={2}
                        // maxLength={100}
                        label="Nome completo da mãe"
                        // value={maskEspeciais((dados as IPessoaFisicaRequestDom)?.nome_mae, true)}
                        value={maskEspeciais((dados as IPessoaFisicaRequestDom)?.nome_mae)}
                        onBlur={(e: any) => {
                            const value = e.target.value.trim()
                            const names = value.split(" ")
                            const atLeastTwoNames = names.length >= 2
                            if (!atLeastTwoNames) {
                                if(isConjuge && !isAvalista){
                                    errorsList$.next([...errorsList, "pessoa_fisica.conjuge#nome_mae_dois_nomes"])
                                }else if(!isConjuge && isAvalista){
                                    errorsList$.next([...errorsList, `avalistas#${indexAvalista}#nome_mae_dois_nomes`])
                                }else if(isConjuge && isAvalista){
                                    errorsList$.next([...errorsList, `avalistas#${indexAvalista}#conjuge.nome_mae_dois_nomes`])
                                }else{
                                    errorsList$.next([...errorsList, "pessoa_fisica#nome_mae_dois_nomes"])
                                }
                            } else {
                                if(isConjuge && !isAvalista){
                                    errorsList$.next(errorsList.filter((error: any)=>error !== `pessoa_fisica#nome_mae_dois_nomes`))
                                }else if(!isConjuge && isAvalista){
                                    errorsList$.next(errorsList.filter((error: any)=>error !== `avalistas#${indexAvalista}#nome_mae_dois_nomes`))
                                }else if(isConjuge && isAvalista){
                                    errorsList$.next(errorsList.filter((error: any)=>error !== `avalistas#${indexAvalista}#conjuge.nome_mae_dois_nomes`))
                                }else{
                                    errorsList$.next(errorsList.filter((item: string) => item !== "pessoa_fisica#nome_mae_dois_nomes"))
                                }
                            }
                        }}
                        helperText={withErrors() ? "O Nome deve conter pelo menos 2 nomes" : ""}
                        onChange={(event: any) => {
                            if (dados) {
                                (dados as IPessoaFisicaRequestDom).nome_mae = event.target.value
                                onChange(dados, resolveTipoPessoa())
                            }
                        }}
                        error={
                            (!isConjuge && !isAvalista && ArrayUtil.contains(errorsList, "pessoa_fisica#nome_mae"))
                            || (isConjuge && !isAvalista && ArrayUtil.contains(errorsList, "pessoa_fisica.conjuge#nome_mae"))
                            || (!isConjuge && isAvalista && ArrayUtil.contains(errorsList, `avalistas#${indexAvalista}#nome_mae`))
                            || (isConjuge && isAvalista && ArrayUtil.contains(errorsList, `avalistas#${indexAvalista}#conjuge.nome_mae`))
                            || ((dados as IPessoaFisicaRequestDom)?.nome_mae || '').trim().split(" ").length < 2
                            // || maskEspeciais((dados as IPessoaFisicaRequestDom)?.nome_mae, true)?.length < 2
                            // || maskEspeciais((dados as IPessoaFisicaRequestDom)?.nome_mae, true)?.length > 100
                            // || !validarTexto((dados as IPessoaFisicaRequestDom)?.nome_mae || '')
                        }
                    />
                </div>
            </>}

            {/* Valor patrimônio / Faturamento Mensal PJ */}
            <div className="X12 M6">
                <InputMoney
                    disabled={readonly}
                    fullWidth
                    label={!isPessoaJuridica ? "Valor do patrimônio" : "Faturamento mensal"}
                    value={!isPessoaJuridica ? (dados as IPessoaFisicaRequestDom)?.patrimonio : (dados as IPessoaJuridicaProponenteRequestDom)?.faturamento_mensal}
                    onChangeValue={(newValue) => {
                        if (dados) {
                            if (isPessoaJuridica) {
                                (dados as IPessoaJuridicaProponenteRequestDom).faturamento_mensal = newValue.numberValue
                            } else {
                                (dados as IPessoaFisicaRequestDom).patrimonio = newValue.numberValue
                            }
                            onChange(dados, resolveTipoPessoa())
                        }
                        handleValidChange();
                    }}
                    error={
                        (!isConjuge && !isAvalista && ArrayUtil.contains(errorsList, "pessoa_fisica#patrimonio"))
                        || (isConjuge && !isAvalista && ArrayUtil.contains(errorsList, "pessoa_fisica.conjuge#patrimonio"))
                        || (!isConjuge && isAvalista && ArrayUtil.contains(errorsList, `avalistas#${indexAvalista}#patrimonio`))
                        || (isConjuge && isAvalista && ArrayUtil.contains(errorsList, `avalistas#${indexAvalista}#conjuge.patrimonio`))
                        || (!isAvalista && ArrayUtil.contains(errorsList, "pessoa_juridica#faturamento_mensal"))
                    }
                    onBlur={()=>{
                        if(!(dados as any)?.patrimonio && !isPessoaJuridica){
                            if(isConjuge && !isAvalista){
                                errorsList$.next([...errorsList, "pessoa_fisica.conjuge#patrimonio"])
                            }else if(!isConjuge && isAvalista){
                                errorsList$.next([...errorsList, `avalistas#${indexAvalista}#patrimonio`])
                            }else if(isConjuge && isAvalista){
                                errorsList$.next([...errorsList, `avalistas#${indexAvalista}#conjuge.patrimonio`])
                            }
                        }else{
                            if(isConjuge && !isAvalista){
                                errorsList$.next(errorsList.filter((error: any)=>error !== `pessoa_fisica.conjuge#patrimonio`))
                            }else if(!isConjuge && isAvalista){
                                errorsList$.next(errorsList.filter((error: any)=>error !== `avalistas#${indexAvalista}#patrimonio`))
                            }else if(isConjuge && isAvalista){
                                errorsList$.next(errorsList.filter((error: any)=>error !== `avalistas#${indexAvalista}#conjuge.patrimonio`))
                            }
                        }
                    }}
                />
            </div>

            {isPessoaJuridica && <div className="X12 M6">
                <InputMoney
                    disabled={readonly}
                    fullWidth
                    label="Capital social"
                    value={(dados as IPessoaJuridicaProponenteRequestDom)?.capital_social}
                    onChangeValue={(newValue) => {
                        if (dados) {
                            (dados as IPessoaJuridicaProponenteRequestDom).capital_social = newValue.numberValue
                            onChange(dados, resolveTipoPessoa())
                        }
                        handleValidChange();
                    }}
                    error={(!isAvalista && !isConjuge && ArrayUtil.contains(errorsList, "pessoa_juridica#capital_social"))}

                />
            </div>}
            {
                (!isConjuge && !isAvalista) && (
                    <div className="X12 M6">
                        <InputMoney 
                            disabled={readonly}
                            fullWidth
                            label="Valor médio pago em conta de luz"
                            value={(dados as IPessoaJuridicaProponenteRequestDom).valor_conta_luz}
                            onChangeValue={(newValue) => {
                                if (dados) {
                                    (dados as IPessoaJuridicaProponenteRequestDom).valor_conta_luz = newValue.numberValue
                                    onChange(dados, resolveTipoPessoa())
                                }
                                handleValidChange();
                            }}
                            error={(!isAvalista && !isConjuge && ArrayUtil.contains(errorsList, "pessoa_juridica#valor_conta_luz")) ||
                                (!isAvalista && !isConjuge && ArrayUtil.contains(errorsList, "pessoa_fisica#valor_conta_luz"))
                            }
                            onBlur={() => {
                                if(!(dados as IPessoaJuridicaProponenteRequestDom).valor_conta_luz){
                                    if(isPessoaFisica){
                                        errorsList$.next([...errorsList, "pessoa_fisica#valor_conta_luz"])
                                    }else{
                                        errorsList$.next([...errorsList, "pessoa_juridica#valor_conta_luz"])
                                    }
                                }
                            }}
                        />
                    </div>
                )
            }

            {(isConjuge || isAvalista) && <>
                <div className="X12 M6">
                    <InputText
                        disabled={readonly}
                        fullWidth
                        label="E-mail"
                        value={(dados as IPessoaFisicaConjugeRequestDom)?.email}
                        onChange={(event: any) => {
                            if (dados) {
                                (dados as IPessoaFisicaConjugeRequestDom).email = event.target.value
                                onChange(dados, resolveTipoPessoa())
                            }
                        }}
                        error={
                            (isConjuge && !isAvalista && ArrayUtil.contains(errorsList, "pessoa_fisica.conjuge#email"))
                            || (!isConjuge && isAvalista && ArrayUtil.contains(errorsList, `avalistas#${indexAvalista}#email`))
                            || (isConjuge && isAvalista && ArrayUtil.contains(errorsList, `avalistas#${indexAvalista}#conjuge.email`))
                        }
                        onBlur={()=>{
                            if(!(dados as any)?.email && !isPessoaJuridica){
                                if(isConjuge && !isAvalista){
                                    errorsList$.next([...errorsList, "pessoa_fisica.conjuge#email"])
                                }else if(!isConjuge && isAvalista){
                                    errorsList$.next([...errorsList, `avalistas#${indexAvalista}#email`])
                                }else if(isConjuge && isAvalista){
                                    errorsList$.next([...errorsList, `avalistas#${indexAvalista}#conjuge.email`])
                                }
                            }else{
                                if(isConjuge && !isAvalista){
                                    errorsList$.next(errorsList.filter((error: any)=>error !== `pessoa_fisica.conjuge#email`))
                                }else if(!isConjuge && isAvalista){
                                    errorsList$.next(errorsList.filter((error: any)=>error !== `avalistas#${indexAvalista}#email`))
                                }else if(isConjuge && isAvalista){
                                    errorsList$.next(errorsList.filter((error: any)=>error !== `avalistas#${indexAvalista}#conjuge.email`))
                                }
                            }
                        }}
                    />
                </div>
                <div className="X12 M6">
                    <InputText
                        maxLength={15}
                        helperText={getTelefoneHelperText()}
                        disabled={readonly}
                        fullWidth
                        label={isAvalista ? "Telefone Celular" : "Telefone"}
                        mask="phone"
                        inputProps={{
                            autocomplete: false,
                        }}
                        value={maskPhone((dados as IPessoaFisicaConjugeRequestDom)?.telefone)}
                        onChange={(event: any) => {
                            if (dados) {
                                (dados as IPessoaFisicaConjugeRequestDom).telefone = event.target.value
                                onChange(dados, resolveTipoPessoa())
                            }
                        }}
                        error={
                            (isConjuge && !isAvalista && ArrayUtil.contains(errorsList, "pessoa_fisica.conjuge#telefone"))
                            || (!isConjuge && isAvalista && ArrayUtil.contains(errorsList, `avalistas#${indexAvalista}#telefone`))
                            || (isConjuge && isAvalista && ArrayUtil.contains(errorsList, `avalistas#${indexAvalista}#conjuge.telefone`))
                            || (phoneError(dados?.telefone))
                        }
                        onBlur={()=>{
                            if(!(dados as any)?.telefone && !isPessoaJuridica){
                                if(isConjuge && !isAvalista){
                                    errorsList$.next([...errorsList, "pessoa_fisica.conjuge#telefone"])
                                }else if(!isConjuge && isAvalista){
                                    errorsList$.next([...errorsList, `avalistas#${indexAvalista}#telefone`])
                                }else if(isConjuge && isAvalista){
                                    errorsList$.next([...errorsList, `avalistas#${indexAvalista}#conjuge.telefone`])
                                }
                            }else{
                                if(isConjuge && !isAvalista){
                                    errorsList$.next(errorsList.filter((error: any)=>error !== `pessoa_fisica.conjuge#telefone`))
                                }else if(!isConjuge && isAvalista){
                                    errorsList$.next(errorsList.filter((error: any)=>error !== `avalistas#${indexAvalista}#telefone`))
                                }else if(isConjuge && isAvalista){
                                    errorsList$.next(errorsList.filter((error: any)=>error !== `avalistas#${indexAvalista}#conjuge.telefone`))
                                }
                            }
                        }}
                    />
                </div>
            </>}

            {isAvalista && (<div className="X12 M6">
                <InputComboBoxList
                    disabled={readonly || !relacionamentosList?.length}
                    label="Relacionamento"
                    textField="nome"
                    valueField="id"
                    value={relacionamentosState}
                    options={configfuracoesFinanceira?.financeira_id === FINANCEIRA_SANTANDER_ID ? relacionamentosList?.filter((_relacionamento: any) => _relacionamento?.empresa_natureza_legal_id === naturezaLegalId?.id) || [] : relacionamentosList}
                    onChange={(_relacionamento: any) => {
                        const _state = CollectionUtil.merge({}, dados)
                        if (_state) {
                            (_state as any).relacionamento_legal = _relacionamento?.id || null
                            setRelacionamentosState(_relacionamento)
                            onChange(_state, resolveTipoPessoa())
                        }
                        handleValidChange();
                    }}
                    error={ArrayUtil.contains(errorsList, `avalistas#${indexAvalista}#relacionamento_legal`)}
                />
            </div>)}

            {/* Estado civil */}
            {configfuracoesFinanceira?.permite_conjuge && !isConjuge && !isPessoaJuridica && <>
                <div className="X12 M6">
                    <InputComboBoxList
                        disabled={readonly}
                        label="Estado civil"
                        textField="nome"
                        valueField="id"
                        value={estadoCivilState}
                        options={ESTADOS_CIVIS}
                        onChange={(_estadoCivil) => {
                            const _state = CollectionUtil.merge({}, dados)
                            if (_state) {
                                _state.estado_civil = _estadoCivil?.id ? _estadoCivil.id : null
                                onChange(_state, resolveTipoPessoa())
                            }
                            handleValidChange();
                        }}
                        error={
                            (!isAvalista && !isConjuge && ArrayUtil.contains(errorsList, "pessoa_fisica#estado_civil"))
                            || (isAvalista && !isConjuge && ArrayUtil.contains(errorsList, `avalistas#${indexAvalista}#estado_civil`))
                        }

                    />
                </div>
                <div className="X12 M6">
                    <InputComboBoxList
                        disabled={readonly || ![String(ESTADO_CIVIL_CASADO_ID)].includes(String((dados as any)?.estado_civil))}
                        label="Regime de bens"
                        textField="nome"
                        valueField="id"
                        value={regimeBensState}
                        options={PARTILHA_BENS}
                        onChange={(_regime) => {
                            const _state = CollectionUtil.merge({}, dados)
                            if (_state) {
                                _state.partilha_bens = _regime?.id || null
                                onChange(_state, resolveTipoPessoa())
                            }

                        }}
                        error={
                            (!isAvalista && !isConjuge && ArrayUtil.contains(errorsList, "pessoa_fisica#partilha_bens"))
                            || (isAvalista && !isConjuge && ArrayUtil.contains(errorsList, `avalistas#${indexAvalista}#partilha_bens`))
                        }
                    />
                </div>
            </>}
        </div>

        <FormEndereco
            key={`pessoa-form-endereco-${pessoaStringType()}`}
            dadosEndereco={dados?.endereco as any || null}
            isPessoaFisica={isPessoaFisica}
            isAvalista={isAvalista}
            isConjuge={isConjuge}
            readonly={readonly}
            errorsList={errorsList}
            indexAvalista={indexAvalista}
            dataNascimento={(dados as IPessoaFisicaRequestDom)?.data_nascimento || (financeira_id === FINANCEIRA_BV_ID ? ((dados as IPessoaJuridicaProponenteRequestDom)?.data_fundacao || null) : null) || null}
            financeira_id={financeira_id || 0}
            isEmpresa={(dados as IPessoaFisicaRequestDom)?.data_nascimento ? false : (financeira_id === FINANCEIRA_BV_ID ? ((dados as IPessoaJuridicaProponenteRequestDom)?.data_fundacao ? true : false) : false)}
            onChangeData={(_endereco) => {
                const _state = CollectionUtil.merge({}, dados)
                _state.endereco = _endereco
                onChange(_state, resolveTipoPessoa())
            }}
        />
        {(isConjuge || isAvalista) && <>
            <div className="row">
                <div className="X12">
                    <h4>Dados profissionais</h4>
                </div>
            </div>
            <FormProfissao
                isPessoaFisica={isPessoaFisica}
                isAvalista={isAvalista}
                isConjuge={isConjuge}
                readonly={readonly}
                errorsList={errorsList}
                indexAvalista={indexAvalista}
                dataNascimento={(dados as IPessoaFisicaRequestDom)?.data_nascimento || null}
                key={`pessoa-form-profissao-${pessoaStringType()}`}
                dadosProfissao={(dados as any)?.ocupacao}
                financeira_id={financeira_id || 0}
                onChange={(_profissao) => {
                    const _state = CollectionUtil.merge({}, dados)
                    _state.ocupacao = _profissao
                    onChange(_state, resolveTipoPessoa())
                }}

            />
        </>}
    </div>
}

export { FormPessoa }
